import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";
import { Template } from "@/types";
import { useTranslation } from "react-i18next";

interface TemplatePreviewButtonProps {
  template: Template;
  onClick: (e: React.MouseEvent) => void;
  variant?: "default" | "ghost" | "outline" | "secondary";
  size?: "default" | "sm" | "lg" | "icon";
  disabled?: boolean;
  showText?: boolean;
}

const TemplatePreviewButton = ({
  template,
  onClick,
  variant = "ghost",
  size = "sm",
  disabled = false,
  showText = false
}: TemplatePreviewButtonProps) => {
  const { t } = useTranslation();
  const hasPreviewContent = template.preview_template_result && template.preview_template_result.trim() !== '';

  // Если нет контента для предпросмотра, не показываем кнопку
  if (!hasPreviewContent) {
    return null;
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      className="flex items-center gap-1 touch-manipulation"
      title={t('templates.common.preview_tooltip')}
      aria-label={t('templates.common.preview_aria')}
    >
      <Eye className={size === "default" ? "h-5 w-5" : "h-4 w-4"} />
      {showText && <span>{t('templates.common.preview_btn')}</span>}
    </Button>
  );
};

export default TemplatePreviewButton;